document.addEventListener("DOMContentLoaded", () => {
  // Only run on collection pages
  if (!window.location.pathname.startsWith("/collections/")) return;

  let currentVariantId = null;

  // Fetch product JSON
  async function fetchProductData(handle) {
    try {
      const res = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return await res.json();
    } catch (err) {
      console.error("Failed to fetch product data:", err);
      return null;
    }
  }

  // Prefer Shopify.formatMoney if available; otherwise fall back
  function formatMoney(cents, defaultFormat = "{{amount_with_currency}}") {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === "function") {
        const moneyFormat =
          window.theme?.moneyFormat ||
          window.Shopify?.money_format ||
          defaultFormat;
        return Shopify.formatMoney(cents, moneyFormat);
      }
    } catch (_) { /* ignore */ }

    const amount = (cents / 100).toFixed(2);
    if (defaultFormat === "{{amount_with_currency}}") return `$${amount}`;
    if (defaultFormat === "{{amount_no_decimals}}") return String(Math.round(cents / 100));
    return amount;
  }

  // Convert HTML description → plain text with preserved basic line breaks
  function htmlToPlainText(html) {
    const withBreaks = (html || "")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n")
      .replace(/<\/div>/gi, "\n");
    const div = document.createElement("div");
    div.innerHTML = withBreaks;
    return (div.textContent || "")
      .replace(/\u00A0/g, " ")       // &nbsp; → regular space
      .replace(/\n{3,}/g, "\n\n")    // collapse excessive blank lines
      .trim();
  }

  // Populate a specific modal with product data
  function populateModal(modal, product) {
    const spinner = modal.querySelector(".quick-view-modal__spinner-wrapper");
    const wrapper = modal.querySelector(".modal-product__wrapper");
    const titleEl = modal.querySelector(".modal-product__title");
    const priceEl = modal.querySelector(".modal-product__price span");
    const vendorEl = modal.querySelector(".modal-product__vendor span");
    const infoEl = modal.querySelector(".main-product__additional-info");
    const img = modal.querySelector(".modal-product__image");
    const placeholder = modal.querySelector(".image-placeholder");
    const qtyInput = modal.querySelector(".product-quantity");

    // Show content
    spinner.style.display = "none";
    wrapper.style.display = "flex";

    // Text fields
    titleEl.textContent = product.title || "";
    priceEl.textContent = formatMoney(product.price, "{{amount_with_currency}}");
    vendorEl.textContent = product.vendor || "Unknown";
    infoEl.textContent = htmlToPlainText(product.description);

    // Variant
    currentVariantId = product?.variants?.[0]?.id || null;

    // Quantity reset
    if (qtyInput) qtyInput.value = 1;

    // Image handling with placeholder
    placeholder.style.display = "flex";
    img.style.display = "none";
    const imageSrc = product?.featured_image || product?.images?.[0] || "";
    if (imageSrc) {
      img.src = imageSrc;
      img.onload = () => {
        placeholder.style.display = "none";
        img.style.display = "block";
      };
      img.onerror = () => {
        placeholder.style.display = "none";
      };
    } else {
      placeholder.style.display = "none";
    }

    // Close controls
    const closeIcon = modal.querySelector(".quick-view-modal__close-icon");
    const closeModal = () => {
      modal.classList.remove("active");
      modal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      modal.removeEventListener("click", overlayCloser);
      closeIcon?.removeEventListener("click", closeModal);
    };
    const overlayCloser = (e) => {
      if (e.target === modal) closeModal();
    };
    closeIcon?.addEventListener("click", closeModal, { once: true });
    modal.addEventListener("click", overlayCloser, { once: true });

    // Add to cart behavior
    const addBtn = modal.querySelector(".quick-view-add-to-cart");
    addBtn.onclick = async () => {
      const q = Number(qtyInput?.value || 1);
      if (!currentVariantId) {
        console.error("No variant to add.");
        return;
      }
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: currentVariantId, quantity: q }),
        });
        if (!res.ok) throw new Error("Failed to add product to cart");
        // brief refresh to reflect cart change (adjust to your UX)
        setTimeout(() => window.location.reload(), 300);
      } catch (err) {
        console.error("Error adding to cart:", err);
      }
    };
  }

  // Open modal on Quick View click
  document.body.addEventListener("click", async (e) => {
    const btn = e.target.closest(".quick-view-button");
    if (!btn) return;

    e.preventDefault();
    const handle = btn.getAttribute("data-product-handle");
    const modal = document.querySelector(`.quick-view-modal[data-product-handle="${handle}"]`);
    if (!modal) {
      console.error("Modal not found for handle:", handle);
      return;
    }

    // Prep loading state
    const spinner = modal.querySelector(".quick-view-modal__spinner-wrapper");
    const wrapper = modal.querySelector(".modal-product__wrapper");
    spinner.style.display = "block";
    wrapper.style.display = "none";

    // Show modal
    document.body.style.overflow = "hidden";
    modal.classList.add("active");
    modal.setAttribute("aria-hidden", "false");

    // Fetch + populate
    const product = await fetchProductData(handle);
    if (product) {
      populateModal(modal, product);
    } else {
      spinner.style.display = "none";
      wrapper.style.display = "flex";
    }
  });
});
